import { SET_FOOTER_LINKS } from "../action/appConfiguration";
import { DEFAULT_FOOTER_LINKS } from "../thunk/fetchAppConfiguration";

const initialState = {
  footerLinks: DEFAULT_FOOTER_LINKS,
};

export default function appConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FOOTER_LINKS:
      return {
        ...state,
        footerLinks: action.payload,
      };
    default:
      return state;
  }
}

